/** 侧导航 **/
<template>
  <el-container class="wrap-nav-content">
    <el-container class="f-df">
      <el-aside :style="{top: navTop}" class="left-menu-box f-pr" width="130">
        <div class="menu-page">
          <slot></slot>
          <!-- :default-active="currentIndex" -->
          <el-menu
            :default-active="currentIndex"
            :default-openeds="defaultOpen"
            :router="true"
            class="menu-box">
            <el-submenu
              v-for="(item, index) in navList"
              :key="index"
              :index="item.path">
              <template slot="title">
                <i :class="item.icon" class="iconfont pd-right10"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group class="menu">
                <el-menu-item
                  v-for="(elem, i) in item.children"
                  :key="i"
                  :index="elem.path">
                  <i :class="elem.icon" class="iconfont pd-right10"></i>
                  <span>{{ elem.name }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
      </el-aside>
      <el-main :style="{'margin-top': navTop}" class="right-main-con-box f-pr">
        <router-view class="flex-1" />
        <!-- <keep-alive>
          <router-view class="flex-1" />
        </keep-alive> -->
        <div v-if="$route.meta && $route.meta.isHasCommonLoginOut" class="login-out-box f-df f-ai">
          <figure></figure>
          <figcaption>{{ ($store.state.userInfo.userName || $store.state.userInfo.account) + '，'}}</figcaption>
          <span class="color-blue f-csp" @click="loginOut">退出</span>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'SideNav',
  props: {
    paramObj: {
      type: Object,
      default: () => {}
    },
    navList: {
      type: Array,
      default: () => ([])
    },
    navTop: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      currentIndex: '',
      defaultOpen: []
    }
  },
  watch: {
    // 监听路由变化
    $route(to) {
      this.selectRoute(to.path)
    },
    navList: {
      handler(newArr) {
        this.defaultOpen = newArr.map(item => {
          return item.path
        })
        const path = this.$route.path || newArr[0].path
        this.selectRoute(path)
      },
      immediate: true, // 首次也监听
      deep: true
    }
  },
  methods: {
    selectRoute(path) {
      if (path === '/login') return
      this.navList.forEach(item => {
        if (item.children) {
          item.children.forEach(elem => {
            const isExit = elem.pathGroup.find(pathElem => pathElem === path)
            if (isExit) this.currentIndex = elem.path
          })
        }
      })
    },
    // 退出
    loginOut() {
      this.$router.push({
        path: '/login'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.wrap-nav-content {
  height: 100%;
  width: 100%;
  min-width: 1100px;
  overflow: hidden;
  box-sizing: border-box;
  & .login-out-box{
    position: fixed;
    top: 10px;
    right: 15px;
    z-index: 99;
  }
  & .left-menu-box{
    width: 208px;
    background: @color-white;
    position: relative;
    z-index: 99;
    box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.12);
    & .menu-page {
      width: 208px;
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      & .menu-box{
        width: 209px;
        min-height: calc(~'100vh - 30px');
      }
    }
  }
  & .right-main-con-box{
    width: calc(~'100vw - 208px');
    // overflow: hidden;
    padding: 0;
    border-left: 1px solid @bor-color-gray;
  }
}
// /deep/.el-menu-item,
// & .menu-page{
//   width: 208px;
// }

/deep/.el-menu-item-group__title {
  padding: 0 0 0 0px;
  line-height: normal;
  font-size: 12px;
  color: #909399;
}
/deep/.el-menu-item {
  text-align: left;
  color: @color-dark;
  height: 38px;
  line-height: 38px;
  padding-left: 15px!important;
  cursor: pointer;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
}
/deep/.el-menu-item:hover{
  background-color: #F1F4F7;
  cursor: pointer;
}
/deep/.el-menu-item.is-active {
  color: @color-blue;
  background: @color-lighter-blue;
  border-right: 2px solid @color-blue;
}
</style>
